import { BrowserFourdApi } from '.';
import { schema } from '../../api/schema';

export class Schema implements schema.Api {
  constructor(private fourd: BrowserFourdApi) {}

  customiseList(request: schema.CustomiseListRequest): Promise<schema.CustomiseListResponse> {
    return this.fourd.twoWayCall<schema.CustomiseListRequest, schema.CustomiseListResponse>(
      request,
      (requestId, request) => {
        this.fourd.call4Dv2('schema.customiseList', request, requestId);
      },
      (response) => {
        return response;
      }
    );
  }

  getLists(request: schema.GetListsRequest): Promise<schema.SchemaResponse<schema.SchemaList[]>> {
    return this.fourd.twoWayCall<schema.GetListsRequest, schema.SchemaResponse<schema.SchemaList[]>>(
      request,
      (requestId, request) => {
        this.fourd.call4Dv2('schema.getLists', request, requestId);
      },
      (response) => {
        return response;
      }
    );
  }
}
